import { render, staticRenderFns } from "./MagTeaserArticles.vue?vue&type=template&id=3b96c435&scoped=true"
import script from "./MagTeaserArticles.vue?vue&type=script&lang=js"
export * from "./MagTeaserArticles.vue?vue&type=script&lang=js"
import style0 from "./MagTeaserArticles.vue?vue&type=style&index=0&id=3b96c435&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96c435",
  null
  
)

export default component.exports